import { render, staticRenderFns } from "./GroupSelectperson.vue?vue&type=template&id=6b0b6312&scoped=true"
import script from "./GroupSelectperson.vue?vue&type=script&lang=js"
export * from "./GroupSelectperson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0b6312",
  null
  
)

export default component.exports